import React from 'react';
import { Button, Dropdown } from 'antd';
import NumberRoll from '@/components/number-roll/NumberRoll';
import integral from '@/assets/icons/integral.png';
import styles from './IntegralDropdown.module.scss';

const IntegralDropdown = ({ userData, onGetMorePoints }) => {
  if (!userData) return null;

  const items = [
    {
      label: (
        <span className={styles.dropDownNumber}>
          剩余积分：
          <span style={{ color: '#1875ff' }}>
            <NumberRoll
              value={userData?.quotaInfo?.total_balance || 0}
              className={styles.integralNumber}
            />
          </span>
        </span>
      ),
      key: 'other',
    },
    {
      label: <Button type="primary">获取更多积分</Button>,
      key: 'more',
    },
  ];

  const handleMenuClick = ({ key }) => {
    if (key === 'more') {
      onGetMorePoints?.();
    }
  };

  return (
    <Dropdown
      menu={{
        items,
        onClick: handleMenuClick,
      }}
      arrow={{ pointAtCenter: true }}
      placement="bottom"
    >
      <button className={styles.integralButton}>
        <img src={integral} alt="积分" className={styles.integralIcon} />
        <NumberRoll
          value={userData?.quotaInfo?.total_balance || 0}
          className={styles.integralNumber}
        />
      </button>
    </Dropdown>
  );
};

export default IntegralDropdown;
